import {NEW_USER} from '../../constant/usertype'
import {ACT_RUNNING, ACT_END} from '../../constant/act_stat'

export function inner_check(condition) {
  let res = false;
  switch (condition) {
    case 'vip':
      if (window.$bus.user.vip_id > 0) {
        res = true
      }
      break;
    case 'no_vip':
      if (window.$bus.user.vip_id === 0) {
        res = true
      }
      break;
    case 'new_user':
      if (window.$bus.user.user_type === NEW_USER) {
        res = true
      }
      break;
    case 'old_user':
      if (window.$bus.user.user_type !== NEW_USER) {
        res = true
      }
      break;
    case 'ge_lv3': //会员且 LV > 3
      if (window.$bus.user.vip_id > 0 && window.$bus.user.level >= 3) {
        res = true
      }
      break;
    case 'lt_lv3': //非会员 且LV < 3
      if (window.$bus.user.vip_id === 0 || window.$bus.user.level < 3) {
        res = true
      }
      break;
    case 'has_lottery_remain_times':
      if (window.$bus.lottery.remain_chance > 0) {
        res = true
      }
      break;
    case 'no_lottery_remain_times':
      if (window.$bus.lottery.remain_chance <= 0) {
        res = true
      }
      break;
    case 'has_vote_remain_times':
      if (window.$bus.vote.remain_times > 0) {
        res = true
      }
      break;
    case 'no_vote_remain_times':
      if (window.$bus.vote.remain_times <= 0) {
        res = true
      }
      break;
  }

  console.log('inner_check',condition,res)


  return res
}



// WEBPACK FOOTER //
// ./src/tools/mgtv/innerCheck.js